import React from 'react';

import { LabelEnum } from 'app/shared/enums';
import { useStyles } from './TerminationGeneratorSidebar.styles';
import { TerminationPreview } from 'app/components/TerminationPreview';

export default function TerminationGeneratorSidebar() {
  const classes = useStyles();

  return (
    <div className={classes.sidebar}>
      <div className={classes.sidebarHeading}>
        {LabelEnum.TerminationGeneratorSidebarHeading}
      </div>
      <TerminationPreview />
    </div>
  );
}
